import Avatar from 'react-avatar';
import packageJson from '../../../package.json';

export default function AccountHeader({
  name,
  role,
  coordinator,
  email,
  phone,
}) {
  return (
    <div className="flex justify-between items-start pt-8 px-5 mb-3">
      <div className="flex-1">
        <h1 className="text-xl font-semibold text-[#0E64D1] max-xs:text-base">
          {name}
        </h1>
        <p className="text-xs font-medium text-[#12131A] max-xs:text-[10px]">
          {role}
          {/* : {coordinator} */}
        </p>
        <p className="text-[#9EACC0]  font-normal text-xs max-xs:text-[10px]">
          {email} &nbsp;| &nbsp;{phone}
        </p>
      </div>
      <div className="flex-shrink-0 flex flex-col items-end">
        <span className="text-xs text-gray-500 mb-1">v{packageJson.version}</span>
        <Avatar name={name} size="45.3" className="rounded-full w-[57px] h-[57px] max-xs:w-[47px] max-xs:h-[47px]" />
      </div>
    </div>
  );
}
